export const commandTemplate = (impression:object | any) => `
<div
  style="
    align-self: stretch;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: flex;
  "
>
  <div
    style="
      align-self: stretch;
      min-height: 25px;
      color: black;
      font-size: 13px;
      font-family: Monospace;
      font-weight: 700;
      word-wrap: break-word;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-left: 1rem;
      margin-right: 1rem;
    "
    >
    <div>
      commander
    </div>
    <div>
      orden: ${impression?.id.slice(0, 6)}
    </div>
  </div>

  <div
    style="
      align-self: stretch;
      min-height: 25px;
      color: black;
      font-size: 13px;
      font-family: Monospace;
      font-weight: 700;
      word-wrap: break-word;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-left: 1rem;
      margin-right: 1rem;
    "
  >
    ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}
  </div>
  <div
    style="
      align-self: stretch;
      color: black;
      font-size: 13px;
      font-family: Monospace;
      font-weight: 700;
      word-wrap: break-word;
      display: flex;
      justify-content: space-between;
      margin-left: 1rem;
      margin-right: 1rem;
    "
  >
    <div>
      MESA: ${impression.table}
    </div>
    <div>
      MESERO: ${impression.vendor.name}
    </div>
  </div>
  <div
    style="
      align-self: stretch;
      height: 0px;
      border: 0;
      border-top: 1px dashed #111;
      margin-top: 10px;
    "
  ></div>
</div>

<div
  style="
    align-self: stretch;
    height: 20px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 4px;
    display: flex;
  "
>
  ${impression.details.map((commander:object | any) => (`
    <div
      style="
        width: 232px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;
        word-wrap: break-word;
        display: flex;
      "
    >
      <div
        style="
          margin-left: 1rem;
          margin-right: 2.5rem;
        "
      >
        ${commander?.quantity}
      </div>
      <div
      style="
        width: 100%;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;
        word-wrap: break-word;
        display: flex;
        flex-direction:column;
      "
      >
        <p>${commander?.name}</p>
        <p>${commander?.description?? ''}</p>
      </div>
    </div>
    <div
      style="
        align-self: stretch;
        height: 0px;
        border: 0;
        border-top: 1px dashed #111;
      "
    ></div>
  `)).join("")}
</div>`;
